import { useEffect, useState } from "react";
import Timer from "../../../fragments/Timer";
import { STATE } from "../Game";

/**
 * A short warm-up timer
 * before a new question starts.
 *
 * Only shown when there was no previoous question.
 */
const Preparing = ({ state, timer: timerState }) => {
  const [timer, setTimer] = useState(timerState);
  useEffect(() => {
    if (state === STATE.PREPARING) {
      setTimer(timerState);
    }
  }, [state, timerState]);

  return (
    <div className="flex flex-col items-center gap-y-4">
      <h1 className="text-3xl">{gettext("Game starting")}</h1>
      <Timer {...timer} />
    </div>
  );
};
export default Preparing;
